import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

// Paths accessible to authenticated users regardless of business entity status.
const EXEMPT_PREFIXES = [
  '/search',
  '/business/setup',
  '/business/details',
  '/login',
  '/register',
  '/verify/',
  '/forgot-password',
  '/reset-password/',
  '/resend-verification',
  '/how-it-works',
  '/our-mission',
  '/contact',
];

const isExempt = (pathname: string) =>
  EXEMPT_PREFIXES.some((p) => pathname === p || pathname.startsWith(p));

export const NavigationGuard = () => {
  const { isAuthenticated, isLoading, isAdmin, businessEntityType, businessEntityVerified } =
    useAuthStore();
  const { pathname } = useLocation();

  if (isLoading || !isAuthenticated || isAdmin) return null;
  if (isExempt(pathname)) return null;

  if (!businessEntityType) {
    return <Navigate to="/business/setup" replace />;
  }

  if (businessEntityVerified !== true) {
    return <Navigate to="/business/details" replace />;
  }

  return null;
};
